// extracted by mini-css-extract-plugin
export default {"muradi-dahb-right":"PageContent_muradi-dahb-right__qvwhq"};